import { Row, Col, Container } from "react-bootstrap";
import OwnerShopProfile from "../../components/OwnerShopProfile/OwnerShopProfile";
import ShopItemsOwner from "../../components/ShopItemsOwner/ShopItems";
import { useParams } from "react-router-dom";
import BackArrow from "../../components/backArrow";
import Managebuttons from "../../components/Manage_Buttons";
import useWholesalerOwnerProfileState from "../../hooks/useWholesalerOwnerProfileState";

const WholeSalerOwnerProfile = () => {
  const { id } = useParams();
  const {
    shopData,
    suggest,
    setSuggest,
    suggestdetail,
    setSuggestdetail,
    suggestdata,
    suggestdatta,
  } = useWholesalerOwnerProfileState(id);

  return (
    <Container>
      <Col md={12} lg={11} className="mx-auto">
        <Row>
          <Col md={12} lg={3} className="p-0">
            <OwnerShopProfile
              shopid={id}
              navigateTo="/update-wholesaler-form"
              Name="Update Wholesaler Profile"
              update="/update-wholesaler-form"
              setSuggest={setSuggest}
              shopData={shopData}
              suggestdatta={suggestdatta}
            />
          </Col>
          <Col md={12} lg={9} className="screenHeight custom_ps-4">
            <div className="Form-Shadow h-100">
              <Row>
                <Col sm={3} md={4} lg={5}>
                  <BackArrow
                    mystyle="ms-0 ps-2 pt-1 d-none d-lg-block"
                    back={`/wholsaler-bussines-Profile/${id}`}
                  />
                </Col>
                <Col sm={9} md={8} lg={7} className="mt-2 pe-4">
                  <Managebuttons id={id} businessurl="/WholesalerShop" />
                </Col>
              </Row>
              <ShopItemsOwner
                suggest={suggest}
                setSuggest={setSuggest}
                suggestdetail={suggestdetail}
                setSuggestdetail={setSuggestdetail}
                urlPass="/wholesaler-owner-view"
                navigateto="/wholeseller-form"
                shopid={id}
                post={`/wholesaler-postadd/${id}`}
                suggestdata={suggestdata}
                shopData={shopData}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};

export default WholeSalerOwnerProfile;
